import { render, staticRenderFns } from "./transcribeDialog.vue?vue&type=template&id=17471172&scoped=true&"
import script from "./transcribeDialog.vue?vue&type=script&lang=js&"
export * from "./transcribeDialog.vue?vue&type=script&lang=js&"
import style0 from "./transcribeDialog.vue?vue&type=style&index=0&id=17471172&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17471172",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17471172')) {
      api.createRecord('17471172', component.options)
    } else {
      api.reload('17471172', component.options)
    }
    module.hot.accept("./transcribeDialog.vue?vue&type=template&id=17471172&scoped=true&", function () {
      api.rerender('17471172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/transcribeDialog.vue"
export default component.exports